import React, { useEffect, useState } from "react";
import {
  Grid,
  InputLabel,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import { HighlightOffOutlined } from "@mui/icons-material";
import Images from "../../../../config/images";

const ImageUploader = ({ projectImage, setProjectImage, errObj }) => {
  // Handle file selection
  const [uploadLoader, setUploadLoader] = useState(false);

  useEffect(() => {
    console.log("projectImage", projectImage);
  }, [projectImage]);
  const handleFileChange = (event) => {
    setUploadLoader(true);
    const file = event.target.files[0];
    if (file) {
      setProjectImage(file);
      setUploadLoader(false);
    }
  };

  // Handle file removal
  const handleRemoveImage = () => {
    setProjectImage(null);
  };

  return (
    <Grid item xs={12} style={{ paddingTop: 10 }}>
      {uploadLoader ? (
        <Grid
          item
          container
          justifyContent="center"
          alignItems="center"
          xs={12}
          minHeight={220}
        >
          <CircularProgress style={{ color: "#274BF1" }} size={26} />
        </Grid>
      ) : (
        <>
          <InputLabel
            shrink
            error={errObj?.documentErr}
            style={{ fontSize: "1rem", color: "#202939" }}
          >
            Project Image
          </InputLabel>

          {projectImage !== null ? (
            <Grid item style={{ width: "100%" }}>
              {displayImagesView(projectImage, handleRemoveImage)}
            </Grid>
          ) : (
            <Grid
              item
              container
              xs={12}
              style={{ position: "relative", marginBottom: "5px" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: 170,
                  border: "1px dashed #9CA3AF",
                  borderRadius: 4,
                  gap: 1,
                  cursor: "pointer",
                }}
                onClick={() => document.getElementById("image-upload").click()}
              >
                <div style={{ width: "24px", height: "24px" }}>
                  <img src={Images.upload_icon} alt="upload-icon"></img>
                </div>
                <InputLabel>
                  <b>
                    <span style={{ cursor: "pointer", color: "#2563EB" }}>
                      Click to upload Images
                    </span>{" "}
                    or drag and drop{" "}
                  </b>
                </InputLabel>
                <InputLabel style={{ fontSize: 12, color: "#6B7280" }}>
                  {"PNG, JPG (max size 1200x800)"}
                </InputLabel>
              </div>

              <input
                id="image-upload"
                type="file"
                accept="image/*"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  opacity: 0,
                  width: "100%",
                }}
                onChange={handleFileChange}
              />

              <FormHelperText
                error={errObj?.documentErr}
                style={{ fontFamily: "Inter Tight" }}
              >
                {errObj?.documentMsg}
              </FormHelperText>
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
};

// Function to display image with delete option
const displayImagesView = (projectImage, handleRemoveImage) => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        borderRadius: 6,
        marginBottom: 10,
        overflow: "hidden",
      }}
    >
      <img
        style={{
          width: "100%",
          height: 250,
          borderRadius: 6,
          objectFit: "cover",
        }}
        src={URL.createObjectURL(projectImage)}
        alt="Uploaded"
      />
      <HighlightOffOutlined
        style={{
          position: "absolute",
          top: 5,
          right: 5,
          cursor: "pointer",
          fontSize: 28,
          color: "red",
          zIndex: 10,
        }}
        onClick={handleRemoveImage}
      />
    </div>
  );
};

export default ImageUploader;
